import { CustomPDFReportCreateOption } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/enums/custom-pdf-report-builder-dropdown-option.enum';
import { CustomPDFReportModuleCategory, CustomPDFReportModuleFieldType, CustomPDFReportModuleSize, CustomPDFReportTearsheetModuleSize, } from 'CustomPDFReportsApp/ts/apps/custom-pdf-report-builder-app/enums/custom-pdf-report-module.enum';
import { CustomPDFReportType } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-type.enum';
import { CustomPDFReportOrientation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-orientation.enum';
import { PublicSharingState } from 'SharingApp/ts/enums/public-sharing-state.enum';
export const EDIT_FORBIDDEN_ERROR_MESSAGE = 'You do not have permission to edit this report template.';
export const LOAD_REPORT_ERROR_MESSAGE = 'An error occurred while loading the report template. Please try again or contact support.';
export const DUPLICATE_REPORT_NAME_ERROR_MESSAGE = 'A report template with this name already exists.';
export const MAX_REPORT_SIZE_ERROR_MESSAGE = 'You have exceeded the maximum report template size of 100 pages. Please remove some pages before saving.';
export const GENERIC_SAVE_ERROR_MESSAGE = 'An error occurred while saving the report template. Please try again or contact support.';
export const LOAD_MODULE_MENU_ERROR_MESSAGE = 'An error occurred while loading report modules. Please try again or contact support.';
export const DEFAULT_PERFORMANCE_DISCLOSURE_FOOTNOTE = 'The performance data quoted presents past performance; past performance does not guarantee future results; ' +
    'the investment return and principal value of an investment will fluctuate; an investor’s shares, when ' +
    'redeemed, may be worth more or less than their original cost; current performance may be lower or higher ' +
    'than the performance data quoted. The most recent month end performance data can be accessed at ' +
    'https://go.ycharts.com/fund_contact_info. (See the Standardized Returns section of this report for ' +
    'standardized returns information).';
export const SAVED_ASSET_MODULE_TYPES = new Set([
    'HALF_PAGE_SAVED_FUND_CHART_MODULE',
    'FULL_PAGE_SAVED_FUND_CHART_MODULE',
    'SAVED_FUND_CHART_FULL_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_FUND_CHART_HALF_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_FUND_CHART_FULL_PAGE_BY_HALF_PAGE_MULTI_SECURITY_TEARSHEET_MODULE',
    'SAVED_FUND_CHART_HALF_PAGE_BY_HALF_PAGE_MULTI_SECURITY_TEARSHEET_MODULE',
    'HALF_PAGE_SAVED_SCATTER_PLOT_MODULE',
    'FULL_PAGE_SAVED_SCATTER_PLOT_MODULE',
    'SAVED_SCATTER_PLOT_FULL_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_SCATTER_PLOT_HALF_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_SCATTER_PLOT_FULL_PAGE_BY_HALF_PAGE_MULTI_SECURITY_TEARSHEET_MODULE',
    'SAVED_SCATTER_PLOT_HALF_PAGE_BY_HALF_PAGE_MULTI_SECURITY_TEARSHEET_MODULE',
    'FULL_PAGE_SAVED_COMP_TABLE_MODULE',
    'HALF_PAGE_SAVED_COMP_TABLE_MODULE',
    'FULL_PAGE_SAVED_TIMESERIES_TABLE_MODULE',
    'HALF_PAGE_SAVED_TIMESERIES_TABLE_MODULE',
    'SAVED_TIMESERIES_TABLE_HALF_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_TIMESERIES_TABLE_FULL_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_COMP_TABLE_FULL_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_COMP_TABLE_HALF_PAGE_BY_HALF_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_MODULE',
    'SAVED_EFFICIENT_FRONTIER_MODULE',
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_COMPARISON_MODULE',
    'SAVED_EFFICIENT_FRONTIER_COMPARISON_MODULE',
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_MULTI_MODULE',
    'SAVED_EFFICIENT_FRONTIER_MULTI_MODULE',
]);
export const TEARSHEET_IMAGE_MODULE_TYPES = new Set([
    'CUSTOM_IMAGE_QUARTER_PAGE_BY_QUARTER_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
    'CUSTOM_IMAGE_HALF_PAGE_BY_HALF_PAGE_TEARSHEET_MODULE',
    'CUSTOM_IMAGE_HALF_PAGE_BY_QUARTER_PAGE_TEARSHEET_MODULE',
    'CUSTOM_IMAGE_HALF_PAGE_BY_EIGHTH_PAGE_SINGLE_SECURITY_TEARSHEET_MODULE',
]);
export const EFFICIENT_FRONTIER_MODULE_TYPES = [
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_MODULE',
    'SAVED_EFFICIENT_FRONTIER_MODULE',
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_COMPARISON_MODULE',
    'SAVED_EFFICIENT_FRONTIER_COMPARISON_MODULE',
    'SAVED_EFFICIENT_FRONTIER_WITH_TABLE_MULTI_MODULE',
    'SAVED_EFFICIENT_FRONTIER_MULTI_MODULE',
];
export const IMAGE_MODULE_TYPES = new Set([
    'FULL_PAGE_IMAGE_MODULE',
    'HALF_PAGE_IMAGE_MODULE',
    ...TEARSHEET_IMAGE_MODULE_TYPES,
]);
export const MODULE_TYPES_WITH_ATTACHMENTS = new Set([...SAVED_ASSET_MODULE_TYPES, ...IMAGE_MODULE_TYPES]);
export const MODULE_TYPES_WITH_RELATED_ITEMS = new Set([
    ...MODULE_TYPES_WITH_ATTACHMENTS,
    'FIXED_SECURITY_TEARSHEETS_MODULE',
]);
export const FIELD_TYPES_WITH_RELATED_ITEMS = new Set([
    CustomPDFReportModuleFieldType.SAVED_ITEM_FIELD,
    CustomPDFReportModuleFieldType.SECURITY,
    CustomPDFReportModuleFieldType.IMAGE,
]);
// Integers represent twelfths of a page
export const MODULE_SIZE_TO_CSS_CLASS = {
    6: 'quarter-page',
    8: 'third-page',
    12: 'half-page',
    24: 'full-page',
};
export const MODULE_SIZE_TO_ICON_NAME = {
    6: 'icon-1-4',
    8: 'icon-1-3',
    12: 'icon-1-2',
};
export const MODULE_SIZE_TO_SIZE_FILTER = {
    6: CustomPDFReportModuleSize.PAGE_SIZE_QUARTER,
    8: CustomPDFReportModuleSize.PAGE_SIZE_THIRD,
    12: CustomPDFReportModuleSize.PAGE_SIZE_HALF,
    24: CustomPDFReportModuleSize.PAGE_SIZE_ONE,
};
export const REPORT_TYPE_TO_CATEGORY_LABEL = {
    [CustomPDFReportType.AGGREGATE_SECURITY_COMPARISON]: 'Comparison',
    [CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW]: 'Overview',
    [CustomPDFReportType.MULTI_SECURITY_COMPARISON]: 'Multi-Comparison',
    [CustomPDFReportType.TEARSHEET_SINGLE_SECURITY]: 'Tearsheet',
    [CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON]: 'Tearsheet',
    [CustomPDFReportType.PRESENTATION]: 'Presentation',
};
export const POSSIBLE_MODULE_SIZES = [24, 12, 8, 6];
export const PAGE_SIZE_MAX = 24;
export const PAGE_WIDTH_MAX = 12;
export const TEARSHEET_PAGE_SIZE_CONVERSION_FACTOR = 3;
export const PROPOSAL_MODULES = new Set(['HALF_PAGE_PROPOSAL_PORTRAIT_MODULE', 'FULL_PAGE_PROPOSAL_PORTRAIT_MODULE']);
export const TRANSITION_ANALYSIS_MODULES = new Set(['TRANSITION ANALYSIS MODULE']);
export var TearsheetModuleTemplateType;
(function (TearsheetModuleTemplateType) {
    TearsheetModuleTemplateType["CUSTOM"] = "custom";
})(TearsheetModuleTemplateType || (TearsheetModuleTemplateType = {}));
export var TargetSecurityChoice;
(function (TargetSecurityChoice) {
    TargetSecurityChoice["FIXED"] = "fixed";
})(TargetSecurityChoice || (TargetSecurityChoice = {}));
export const TEARSHEET_MODULES = [
    'DYNAMIC_TEARSHEETS_MODULE',
    'DYNAMIC_TEARSHEETS_COMPARISON_MODULE',
    'DYNAMIC_TEARSHEETS_MULTI_SECURITY_MODULE',
];
export const CORRELATION_HEATMAP_MODULES = [
    'CORRELATION_HEATMAP_MODULE',
    'CORRELATION_HEATMAP_COMPARISON_MODULE',
    'CORRELATION_HEATMAP_MULTI_MODULE',
];
export const FIXED_TARGET_SECURITY_MODULES = [...TEARSHEET_MODULES, ...CORRELATION_HEATMAP_MODULES];
export const DEFAULT_MODULE_SIZE_FILTERS = {
    all: true,
    [CustomPDFReportModuleSize.PAGE_SIZE_QUARTER]: false,
    [CustomPDFReportModuleSize.PAGE_SIZE_THIRD]: false,
    [CustomPDFReportModuleSize.PAGE_SIZE_HALF]: false,
    [CustomPDFReportModuleSize.PAGE_SIZE_ONE]: false,
};
export const DEFAULT_TEARSHEET_MODULE_SIZE_FILTERS = {
    all: true,
    [CustomPDFReportTearsheetModuleSize.QUARTER_PAGE_BY_QUARTER_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_EIGHTH_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_EIGHTH_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_QUARTER_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE]: false,
    [CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE]: false,
};
export const DEFAULT_REPORT_DATA_FOR_UNSAVED_GENERATION = {
    preview_image_url: null,
    report_description: 'Default report description',
    report_footer: null,
    report_id: 0,
    report_name: 'Unsaved Report Name',
    report_type: CustomPDFReportType.AGGREGATE_SECURITY_OVERVIEW,
    report_category: '',
    report_orientation: CustomPDFReportOrientation.PORTRAIT,
    wizard_steps: [],
    data_source: '',
    advanced_options: null,
    sharing: {
        public_sharing_state: PublicSharingState.NOT_SHARED,
    },
    id: 0,
    name: 'Unsaved Report Name',
    performance_disclosure_footnote: DEFAULT_PERFORMANCE_DISCLOSURE_FOOTNOTE,
};
export const ALL_CATEGORIES_COLLAPSED = Object.values(CustomPDFReportModuleCategory).reduce((acc, category) => {
    acc[category] = false;
    return acc;
}, {});
export const CREATE_REPORT_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Blank Custom Report Template',
        value: CustomPDFReportCreateOption.BLANK_REPORT,
        icon: 'icon-blank',
    },
    {
        type: 'option',
        label: 'New From YCharts Template',
        value: CustomPDFReportCreateOption.NEW_FROM_TEMPLATE,
        icon: 'icon-overview',
    },
];
export const TEARSHEET_REPORT_TYPE_DROPDOWN_BASE_CONFIG = {
    title: {
        label: 'SIZES',
        value: 'All',
    },
    list: [
        {
            label: '(Select All)',
            value: 'all',
            selected: true,
            dividerUnder: true,
        },
    ],
};
export const MODULE_SIZE_TO_TEARSHEET_REPORT_TYPE = {
    12: {
        24: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE,
        12: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE,
        6: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_QUARTER_PAGE,
        3: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_EIGHTH_PAGE,
    },
    6: {
        12: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE,
        6: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE,
        3: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_EIGHTH_PAGE,
    },
    3: {
        6: CustomPDFReportTearsheetModuleSize.QUARTER_PAGE_BY_QUARTER_PAGE,
    },
};
export const TEARSHEET_REPORT_TYPE_TO_MODULE_INFO = {
    [CustomPDFReportType.TEARSHEET_SINGLE_SECURITY]: {
        [CustomPDFReportOrientation.PORTRAIT]: [
            {
                pageSize: 24,
                icon: 'icon-module-portrait-full-color',
                pageWidth: 12,
                label: '1 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-portrait-half-color',
                pageWidth: 12,
                label: '1/2 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-portrait-quarter-vertical-color',
                pageWidth: 6,
                label: '1/4 Page Vertical',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-portrait-quarter-horizontal-color',
                pageWidth: 12,
                label: '1/4 Page Horiz.',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_QUARTER_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-portrait-eighth-vertical-color',
                pageWidth: 6,
                label: '1/8 Page Vertical',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE,
            },
            {
                pageSize: 3,
                icon: 'icon-module-portrait-eighth-horizontal-color',
                pageWidth: 12,
                label: '1/8 Page Horiz.',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_EIGHTH_PAGE,
            },
            {
                pageSize: 3,
                icon: 'icon-module-portrait-sixteenth-color',
                pageWidth: 6,
                label: '1/16 Page',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_EIGHTH_PAGE,
            },
        ],
        [CustomPDFReportOrientation.LANDSCAPE]: [
            {
                pageSize: 24,
                icon: 'icon-module-landscape-full-color',
                pageWidth: 12,
                label: '1 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-landscape-half-color',
                pageWidth: 12,
                label: '1/2 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-landscape-quarter-color',
                pageWidth: 6,
                label: '1/4 Page',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-landscape-eighth-color',
                pageWidth: 6,
                label: '1/8 Page',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-landscape-sixteenth-color',
                pageWidth: 3,
                label: '1/16 Page',
                value: CustomPDFReportTearsheetModuleSize.QUARTER_PAGE_BY_QUARTER_PAGE,
            },
        ],
    },
    [CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON]: {
        [CustomPDFReportOrientation.PORTRAIT]: [
            {
                pageSize: 24,
                icon: 'icon-module-portrait-multicomp-full-color',
                pageWidth: 12,
                label: '1 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-portrait-multicomp-half-color',
                pageWidth: 12,
                label: '1/2 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-portrait-multicomp-quarter-vertical-color',
                pageWidth: 6,
                label: '1/4 Page Vertical',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-portrait-multicomp-quarter-horizontal-color',
                pageWidth: 12,
                label: '1/4 Page Horiz.',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_QUARTER_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-portrait-multicomp-sixteenth-color',
                pageWidth: 6,
                label: '1/8 Page',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE,
            },
        ],
        [CustomPDFReportOrientation.LANDSCAPE]: [
            {
                pageSize: 24,
                icon: 'icon-module-landscape-multicomp-full-color',
                pageWidth: 12,
                label: '1 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_FULL_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-landscape-multicomp-half-color',
                pageWidth: 12,
                label: '1/2 Page',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 12,
                icon: 'icon-module-landscape-multicomp-quarter-vertical-color',
                pageWidth: 6,
                label: '1/4 Page Vertical',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_HALF_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-landscape-multicomp-quarter-horizontal-color',
                pageWidth: 12,
                label: '1/4 Page Horiz.',
                value: CustomPDFReportTearsheetModuleSize.FULL_PAGE_BY_QUARTER_PAGE,
            },
            {
                pageSize: 6,
                icon: 'icon-module-landscape-multicomp-eighth-color',
                pageWidth: 6,
                label: '1/8 Page',
                value: CustomPDFReportTearsheetModuleSize.HALF_PAGE_BY_QUARTER_PAGE,
            },
        ],
    },
};
export const TEARSHEET_REPORT_TYPE_TO_PAGE_DIMENSIONS = {
    [CustomPDFReportType.TEARSHEET_SINGLE_SECURITY]: {
        [CustomPDFReportOrientation.PORTRAIT]: {
            width: 2,
            height: 8,
            x_coordinate_conversion_factor: 6,
            y_coordinate_conversion_factor: 1,
        },
        [CustomPDFReportOrientation.LANDSCAPE]: {
            width: 4,
            height: 4,
            x_coordinate_conversion_factor: 3,
            y_coordinate_conversion_factor: 2,
        },
    },
    [CustomPDFReportType.TEARSHEET_MULTI_SECURITY_COMPARISON]: {
        [CustomPDFReportOrientation.PORTRAIT]: {
            width: 2,
            height: 4,
            x_coordinate_conversion_factor: 6,
            y_coordinate_conversion_factor: 2,
        },
        [CustomPDFReportOrientation.LANDSCAPE]: {
            width: 2,
            height: 4,
            x_coordinate_conversion_factor: 6,
            y_coordinate_conversion_factor: 2,
        },
    },
};
